import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import PaymentMethodForm from '../../../components/PaymentMethodForm/PaymentMethodForm';

const styles = (theme) =>
	({
		root:
		{
			padding: '20px'
		},
		dialogPaper:
		{
			borderRadius: '20px',
			width: '20vw',
			[theme.breakpoints.down('lg')]:
			{
				width: '30vw'
			},
			[theme.breakpoints.down('md')]:
			{
				width: '40vw'
			},
			[theme.breakpoints.down('sm')]:
			{
				width: '50vw'
			},
			[theme.breakpoints.down('xs')]:
			{
				width: '60vw'
			}
		}
	});

const DialogContent = withStyles((theme) => ({
	root:
	{
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: theme.spacing(3),
		backgroundColor: 'white'
	}
}))(MuiDialogContent);

const PaymentMethodModal = ({
	handleClose,
	handleSave,
	open,
	classes
}) =>
{
	return (
		<Dialog
			className={classes.root}
			open={open}
			onClose={() => handleClose(false)}
			classes={{
				paper: classes.dialogPaper
			}}
		>
			<DialogContent>
				<PaymentMethodForm onSubmit={handleSave} modal/>
			</DialogContent>
		</Dialog>
	);
};

PaymentMethodModal.propTypes =
{
	handleClose: PropTypes.func.isRequired,
	handleSave: PropTypes.func.isRequired,
	open: PropTypes.bool.isRequired,
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(PaymentMethodModal);